export default __webpack_public_path__ + "static/beTheCange-dca72e39af5331ac1886706a6725efb4.svg";